import { useState } from 'react'
import CommonDialog from './CommonDialog'
import { Grid } from '@mui/material';
import { CompetitorCard } from './CompetitorCard';
import SegmentWiseReportsImage from "./../assets/competitor/segment-wise-reports.svg";
import NLReportsImage from "./../assets/competitor/nl-reports.svg";
import AnnualReportsImage from "./../assets/competitor/annual-reports.svg";


const CaOptionsModal = () => {

    const [showOptionsModal, setShowOptionsModal] = useState(true);


    const handleClick = (option: string) => {
        setShowOptionsModal(false);
        localStorage.setItem("selectedCAOption", option);
    };

    const cardData = [
        {
            option: "annualReports",
            image: AnnualReportsImage,
            title: "Annual Reports",
            description: "Know about annual insurance reports.",
            buttonText: "Chat",
            link: "/company/annual"
        },
        {
            option: "segmentWiseReports",
            image: SegmentWiseReportsImage,
            title: "Segment wise Reports",
            description: "Know about segment wise reports.",
            buttonText: "Chat",
            link: "/company/segmentwise",
        },
        {
            option: "nlReports",
            image: NLReportsImage,
            title: "NL Reports",
            description: "Know about NL insurance reports.",
            buttonText: "Chat",
            link: "/company/nl"

        },
    ]


    return (
        <CommonDialog
            title='Select an option to continue'
            open={showOptionsModal}
            onClose={() => setShowOptionsModal(false)}
            disableBackdropClick={true}
            size='xl'
        >
            <Grid container spacing={2} justifyContent={"center"}>
                {cardData.map((card) => (
                    <CompetitorCard key={card.title} {...card} onClick={() => handleClick(card.option)} />
                ))}
            </Grid>
        </CommonDialog>
    )
}

export default CaOptionsModal